import {
  SearchResult,
  SearchResultBody,
} from '@thyme/libs/src/meiliSearch/types'
import { type PropType } from 'vue'

export const SEARCH_HIGHLIGHT_PROPS = {
  option: {
    type: Object as PropType<SearchResult>,
    required: true,
  },
  splitMarker: {
    type: String,
    default: '__MARK__',
  },
  attribute: {
    type: String as PropType<keyof SearchResultBody>,
    required: true,
  },
}
